// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-view button.outline {
    border: 1px solid #e0dfdf;
}
.pagination-view .btn-group .btn {
    font-size: 14px !important;
  }
  
.pagination-view button.btn:hover {
    background-color: var(--theme1);
    color: var(--white);
    font-weight: 500;
}

.pagination-view button.btn.active {
    background-color: var(--theme1);
    color: var(--white);
    font-weight: 500;
}

@media screen and (max-width: 768px) {
    .pagination-view .btn-group {
        display: block !important;
        font-size: 12px !important;
    }

    .pagination-view .btn-group>.btn:not(:last-child):not(.dropdown-toggle),
    .btn:nth-child(n+3),
    .btn-group>:not(.btn-check)+.btn {
        border-radius: 20px !important;
    }

    .pagination-view .css-1gak8h1-MuiToolbar-root-MuiTablePagination-toolbar {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/paginationView.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;EAC5B;;AAEF;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;QACI,yBAAyB;QACzB,0BAA0B;IAC9B;;IAEA;;;QAGI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;;AAEJ","sourcesContent":[".pagination-view button.outline {\n    border: 1px solid #e0dfdf;\n}\n.pagination-view .btn-group .btn {\n    font-size: 14px !important;\n  }\n  \n.pagination-view button.btn:hover {\n    background-color: var(--theme1);\n    color: var(--white);\n    font-weight: 500;\n}\n\n.pagination-view button.btn.active {\n    background-color: var(--theme1);\n    color: var(--white);\n    font-weight: 500;\n}\n\n@media screen and (max-width: 768px) {\n    .pagination-view .btn-group {\n        display: block !important;\n        font-size: 12px !important;\n    }\n\n    .pagination-view .btn-group>.btn:not(:last-child):not(.dropdown-toggle),\n    .btn:nth-child(n+3),\n    .btn-group>:not(.btn-check)+.btn {\n        border-radius: 20px !important;\n    }\n\n    .pagination-view .css-1gak8h1-MuiToolbar-root-MuiTablePagination-toolbar {\n        padding-left: 0 !important;\n        padding-right: 0 !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
